import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';

function BootstrapDialogTitle(props) {
	const { children, onClose, ...other } = props;

	return (
		<DialogTitle sx={{ m: 0, p: 2 }} {...other}>
			{children}
			{onClose ? (
				<IconButton
					aria-label="close"
					onClick={onClose}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}>
					<CloseIcon />
				</IconButton>
			) : null}
		</DialogTitle>
	);
}

export default function Modal({
	modalTitle,
	open,
	handleClose,
	children,
	width,
}) {
	return (
		<>			
			<Dialog
				fullWidth
				maxWidth={width || 'md'}
				open={open}
				onClose={handleClose}>
				<BootstrapDialogTitle id="modal-title" onClose={handleClose}>
					{modalTitle}
				</BootstrapDialogTitle>
				<DialogContent sx={{ overflow: 'auto' }}>{children}</DialogContent>
				<DialogActions>
				</DialogActions>
			</Dialog>
		</>
	);
}
